<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update'
  },
  props: {
    value: {
      type: [Array, Number, String],
      default: () => null
    },
    file: {
      type: [Object, String],
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    labelSize: {
      type: Number,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'image'
    }
  },
  data() {
    return {
      temp: ''
    }
  },
  watch: {
    value: {
      handler(val) {
        this.temp = val
      },
      immediate: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('update', value)
    },
    async handleUpload() {
      this.$refs.file.click()
    }
  }
}
</script>

<template>
  <div
    class="base-input-question-file"
  >
    <md-field
      style="
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      "
    >
      <div
        v-if="label"
        class='input-label'
        style="
          text-align: left;
          margin-bottom: 8px;
          width: 100%;
        "
      >
        <label
          style="
            color: #333;
            font-weight: bold;
            position: relative;
          "
          :style="'font-size: ' + (labelSize ? labelSize : 14) + 'px'"
        >
          {{ label }}
        </label>
      </div>

      <input
        type="file"
        :accept="accept"
        :key="value"
        ref="file"
        style="display: none"
        @change="$emit('file-selected', $refs.file.files)"
      />

      <el-input
        v-if="!disabled"
        v-model="temp"
        v-on="$listeners"
        v-loading="loading"
        @change="handleChange"
      >
        <el-button slot="prepend" @click="handleUpload">
          <svg-icon :iconClass="iconClass" />
        </el-button>
        <el-button slot="append" @click.native="$emit('clear', $event)">
          <md-icon>close</md-icon>
        </el-button>
      </el-input>

      <el-input
        v-if="disabled"
        :value="value | answerGoogleDriveMedia"
      >
        <el-button slot="prepend" @click="handleUpload">
          <svg-icon :iconClass="iconClass" />
        </el-button>
      </el-input>
    </md-field>
  </div>
</template>

<style lang="scss">
.base-input-question-file {
  .input-label label {
    left: initial;
    top: initial;
  }

  .el-input {
    // background: rgba(0, 0, 0, 0.05) !important;
    // box-shadow: 0 8px 20px rgba($color: #000000, $alpha: 0.16) !important;
    border: 1px solid transparent !important;
    border-radius: 5px;
    margin: 0 !important;
    width: 100% !important;
    height: 42px !important;
  }

  .el-input__inner {
    background: rgba(0, 0, 0, 0.05) !important;
    border: 1px solid transparent !important;
    padding: 0 6px;
  }

  .el-input-group__prepend, .el-input-group__append {
    border: 1px solid transparent !important;
    background: rgba(0, 0, 0, 0.05) !important;
    padding: 0 10px;

    .svg-icon {
      width: 32px;
      height: 32px;
    }
  }

  input {
    height: 42px !important;
  }
  .md-field:after {
    height: 0 !important;
  }
  .md-field:before {
    height: 0 !important;
  }
}
@media only screen and (max-width: 320px) {

}
@media only screen and (max-width: 480px) {

}
@media only screen and (max-width: 600px) {

}
@media only screen and (max-width: 768px) {

}
@media only screen and (max-width: 900px) {

}
@media only screen and (max-width: 1024px) {

}
</style>
